import { Component, Input } from '@angular/core';
import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { Observable } from 'rxjs';
import { FullProfileAnimationModel } from '../../../../../Core/Dialogs/models/full-profile-animation.model';


@Component({
    selector: 'agpr-online-boost-confirmation-dialog.component',
    templateUrl: './online-boost-confirmation-dialog.component.html',
    styleUrls: ['./online-boost-confirmation-dialog.component.scss'],
    standalone: false
})
export class OnlineBoostConfirmationDialogComponent extends AbstractDialogComponent {
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;

    hideSlideOverlay: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;
    hasAgreed = false;

    constructor(public coreDialogService: CoreDialogService) {
        super(coreDialogService, 'OnlineBoostConfirmation');
    }

    /**
     * Action when the user clicks the "OK" button
     */
    ok(): void {
        this.closeDialog(true);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog(false);
    }

}
